module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout-page', [_c('v-tabs', {
    attrs: {
      "color": "transparent"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.id,
      attrs: {
        "href": ("#" + (tab.id)),
        "disabled": tab.id === 'tab-channels'
      }
    }, [_vm._v(_vm._s(tab.text) + "\n        ")])
  })), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "id": "tab-tracks",
      "transition": false,
      "reverse-transition": false
    }
  }, [_c('tracks-filters', {
    on: {
      "input": _vm.updateFilters
    }
  }), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "length": _vm.last_page,
      "total-visible": _vm.$vuetify.breakpoint.xsOnly ? 5 : 7
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }), _vm._v(" "), _c('app-grid-list', _vm._l((_vm.tracks), function(track) {
    return _c('v-flex', {
      key: track.id,
      attrs: {
        "xs12": "",
        "sm4": "",
        "md3": "",
        "lg2": ""
      }
    }, [_c('audio-teaser', {
      attrs: {
        "audio": track
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-channels",
      "transition": false,
      "reverse-transition": false
    }
  }, [_vm._v("\n            []...\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-543a870e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PageBrowse.vue
// module id = 367
// module chunks = 0